import { IELTContact } from 'legacy/lut/classes/models/partner360/ELT/IELTContact'
import { IAttendee } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { DropdownAutocomplete } from 'legacy/lut/components/widgets/public/partner360/editors/DropdownAutocomplete'
import { IColumn } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/types'

import { Input } from 'core-components/library/inputs'
import { Crud } from 'core/types/Crud'

import { getFormedEltTranslation } from '../../../../helpers/getFormedEltTranslation'

interface IProps {
  onChange: (field: string, index: number) => (value: string) => void
  crud: Crud<IELTContact, number | string>
}

export const getCompAttendeesColumns = ({ onChange, crud }: IProps): IColumn<IAttendee>[] => {
  return [
    {
      title: getFormedEltTranslation('attendees-table-email'),
      field: 'Email',
      renderComponent: ({ value, index }) => (
        <DropdownAutocomplete<IELTContact>
          onChange={onChange('Email', index)}
          value={value || ''}
          fieldsToSearch={['Email', 'FullName']}
          calculateCaption={(item: IObjectAny) =>
            `${item.FirstName || ''} ${item.LastName || ''} <${item.Email}>`
          }
          source={crud}
          validateName="Id"
          mode="combobox"
          onItemChange={(value) => {
            onChange('Name', index)(`${value.FirstName} ${value.LastName}`)
            onChange('Title', index)(value.Roles || '')
          }}
          translation="jbp-hpcontactinfo-email-required"
        />
      ),
    },
    {
      title: getFormedEltTranslation('attendees-table-name'),
      field: 'Name',
      renderComponent: ({ value, index }) => (
        <Input value={value || ''} onChange={onChange('Name', index)} />
      ),
    },
    {
      title: getFormedEltTranslation('attendees-table-title'),
      field: 'Title',
      renderComponent: ({ value, index }) => (
        <Input value={value || ''} onChange={onChange('Title', index)} />
      ),
    },
  ]
}
